<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import { invoiceControlManagement } from "@state/helpers";
import CustomMultiselect from "@/src/components/CustomMultiselect.vue";
import DatePickerRange from "@components/form/DatePickerRange.vue";
import ModalInfo from "@components/invoice_control/modal_info.vue";
import ConfirmModal from "@components/ConfirmModal.vue";
export default {
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    CustomMultiselect,
    DatePickerRange,
    ModalInfo,
    ConfirmModal,
  },
  data() {
    return {
      title: "Invoice Control",
      tableHeaders: [
        {
          key: "date",
          label: this.$t("Fecha"),
        },
        {
          key: "siesa_id",
          label: this.$t("Factura"),
        },
        {
          key: "dataphone_log.approval_code",
          label: this.$t("Aprobacion CB"),
        },
        {
          key: "terminal",
          label: this.$t("Terminal CB"),
        },
        {
          key: "status",
          label: this.$t("Estado"),
        },
        {
          key: "error",
          label: this.$t("Detalle"),
        },
        {
          key: "actions",
          label: this.$t("Acciones"),
        },
      ],
      action: "",

      toDelete: {},
      isSubmitting: false,
      submitting: false,
      showModalInfo: false,
      detailInfo: null,
      filterset: "",
      filters: {
        start_date: null,
        end_date: null,
        status: null,
      },
      statusOptions: [
        {
          label: "Aprobada",
          value: 6,
        },
        {
          label: "Error",
          value: 7,
        },
        {
          label: "En elaboración",
          value: 10,
        },
      ],
      showEditInfo: false,
      newSiesaID: "",
      showConfirmModal: false,
    };
  },
  methods: {
    ...invoiceControlManagement,

    myProvider(ctx) {
      ctx = this.$table_params(ctx);
      ctx += this.filterset ? `&${this.filterset}` : "";
      const promise = this.fetchInvoiceEuroSmartCart(ctx);
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    getFilter() {
      this.lastFilter = "";
      console.log("getFilter");
      this.$refs.table.onFiltered();
      console.log("getFilter");
      setTimeout(() => this.$refs.table.refresh(), 200);
    },

    clear() {
      this.filters.status = null;
      this.filters.end_date = null;
      this.filters.start_date = null;
      this.filterset = null;
      setTimeout(() => this.$refs.table.refresh(), 200);
    },
    setFilter(filter, value) {
      this.filters[filter] = value;
      console.log(value);
    },
    oncancel() {
      this.showModalInfo = false;
    },
    submit() {
      this.submitting = true;
      console.log(this.newSiesaID);
      console.log(this.detailInfo.id);
      let payload = {
        siesa_id: this.newSiesaID,
        status: 6,
        error: null,
        id: this.detailInfo.id,
      };
      console.log(payload);
      const promise = this.patchInvoiceEuroSmartCart(payload);
      return promise
        .then((data) => {
          this.$generate_toast(this, "success", "Edición de factura correcta");
          this.submitting = false;
          this.showConfirmModal = false;
          this.showEditInfo = false;
          this.newSiesaID = "";
          setTimeout(() => this.$refs.table.refresh(), 200);
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          this.submitting = false;
        });
    },
    toggleReadonly(event) {
      if (event.target.getAttribute("readonly") == "readonly") {
        event.target.removeAttribute("readonly");
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`);
          }
        }
        // if (filters_list.length) {
        this.filterset = filters_list.join("&");
        this.getFilter();
      },
    },
  },
};
</script>

<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              <label for="">Estado</label>
              <CustomMultiselect
                v-model="filters.status"
                :options="statusOptions"
                @input="(value) => setFilter('status', value)"
              ></CustomMultiselect
            ></b-col>
            <b-col>
              <DatePickerRange
                :label="'Fecha'"
                :value_start="filters.start_date"
                :value_end="filters.end_date"
                @input_start="(value) => setFilter('start_date', value)"
                @input_end="(value) => setFilter('end_date', value)"
              ></DatePickerRange
            ></b-col>
            <b-col class="pt-3 pr-1 mt-1">
              <b-button
                class="rounded shadow-sm float-right"
                variant="outline-primary"
                @click="clear"
                ><i class="fas fa-eraser"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <BaseDatatable
            ref="table"
            :drfprovider="myProvider"
            :tableheaders="tableHeaders"
            :filterOption="false"
          >
            <template #cell(date)="row">
              <p style="text-wrap: nowrap" class="m-0 p-0">
                {{ row.item.created_at.slice(0, 10) }}
              </p>
            </template>
            <template #cell(siesa_id)="row">
              <p style="text-wrap: nowrap" class="m-0 p-0">
                {{ row.item.siesa_id }}
              </p>
            </template>
            <template #cell(status)="row">
              <b-button
                v-if="row.item.status == 6"
                v-b-tooltip.hover
                variant="btn-link text-info btn-transparent "
                title="Aprobada"
                ><i class="fe-check fe-2x"></i
              ></b-button>
              <b-button
                v-else-if="row.item.status == 7"
                v-b-tooltip.hover
                variant="btn-link text-danger btn-transparent "
                title="Error"
                ><i class="fe-x fe-2x"></i
              ></b-button>
              <b-button
                v-else-if="row.item.status == 10"
                v-b-tooltip.hover
                variant="btn-link text-warning btn-transparent "
                title="En elaboración"
                ><i class="fe-alert-triangle fe-2x"></i
              ></b-button>
            </template>
            <template #cell(actions)="row">
              <b-button
                :id="`info-btn-${row.index}`"
                v-b-tooltip.hover="{
                  variant: 'info',
                  placement: 'leftbottom',
                  title: $t('info'),
                }"
                variant="btn-link text-info btn-transparent"
                @click="
                  () => {
                    showModalInfo = true;
                    detailInfo = row.item;
                  }
                "
              >
                <i class="fas fa-info"></i>
              </b-button>

              <b-button
                :id="`edit-btn-${row.index}`"
                v-if="row.item.status == 7"
                class="mx-2"
                v-b-tooltip.hover="{
                  variant: 'info',
                  placement: 'leftbottom',
                  title: $t('edit'),
                }"
                variant="btn-link text-info btn-transparent"
                @click="
                  () => {
                    showEditInfo = true;
                    detailInfo = row.item;
                  }
                "
              >
                <i class="fas fa-pen"></i>
              </b-button>
            </template>
          </BaseDatatable>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="showModalInfo"
      :title="`${$t('detail_of')} ${$t('issue')}`"
      ok-only
      hide-footer
      @hidden="oncancel"
      size="xl"
    >
      <ModalInfo :detailInfo="detailInfo"></ModalInfo
    ></b-modal>

    <b-modal
      v-model="showEditInfo"
      :title="`Nuevo id Siesa`"
      ok-only
      hide-footer
      centered
      @hidden="oncancel"
      size="sm"
    >
      <b-form-group id="input-group-1">
        <b-form-input
          id="newSiesaID"
          v-model="newSiesaID"
          ref="userDocument"
          type="text"
          required
          placeholder="Ingrese el nuevo id siesa"
          class="border border-primary"
          autocomplete="off"
          autofocus
          @focus="toggleReadonly"
        ></b-form-input>
        <b-button
          class="rounded-lg float-right mt-2"
          variant="primary"
          v-if="!this.submitting"
          @click="
            () => {
              showConfirmModal = true;
            }
          "
        >
          Guardar <i class="fe-save"></i>
        </b-button>
        <b-button v-else>
          <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        </b-button>
      </b-form-group>
    </b-modal>
    <ConfirmModal
      v-if="showConfirmModal"
      :closeModal="
        () => {
          showConfirmModal = false;
        }
      "
      :onSubmit="submit"
      :submitting="submitting"
      :warningMessage="'¿Con seguridad va asignar cambiar el estado y el id de siesa de esta factura?'"
    />
  </b-container>
  <!-- Detail modal -->
</template>
